<div class="page">
  <div class="header">
    <button mat-icon-button (click)="cerrar()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div>
      <h1>Agregar estudio</h1>
    </div>
  </div>

  <mat-dialog-content class="dialog-content">
    <form [formGroup]="form" class="dialog-form">
      <mat-form-field appearance="outline">
        <mat-label>Nombre del estudio </mat-label>
        <input matInput formControlName="nombre" placeholder="Ej. Indice Homa" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Indicaciones</mat-label>
        <input matInput formControlName="indicaciones" placeholder="Ej. Tomarlo en ayunas" />
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button class="add-boton" mat-flat-button color="primary" type="button" (click)="guardar()">
      {{ data?.estudio ? 'Guardar cambios' : 'Agregar' }}
      <mat-icon>add</mat-icon>
    </button>
  </mat-dialog-actions>
</div>
